/**
 * 系统设置模块
 *
 * 系统级配置项管理（图床大小等）
 */

import type { WorkbenchModule } from '../types'

export const settingsModule: WorkbenchModule = {
  meta: {
    name: 'settings',
    title: '系统设置',
    description: '系统级配置项管理，如图床大小上限',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/settings',
      name: 'settings',
      component: () => import('./views/SystemSettingsView.vue'),
      meta: { title: '系统设置' }
    }
  ],
  menuItem: {
    id: 'settings',
    label: '系统设置',
    path: '/settings',
    icon: 'settings',
    order: 60
  }
}
